<template>
    <div>
        <el-row>
            <el-col :span="8">
                <el-result icon="success" :title="$strings('cpsite/send/submit_success')"
                           :subTitle="$strings('cpsite/send/submit_success_sub')">
                    <template slot="extra">
                        <el-button type="primary" size="medium" @click="toReport" class="min-width-160"
                                   style="margin-bottom: 1em;">
                            {{ $strings('cpsite/send/submit_success_to_report') }}
                        </el-button>
                        <br>
                        <el-button size="medium" @click="toSend" class="min-width-160">
                            {{ $strings('cpsite/send/submit_success_to_report_again') }}
                        </el-button>
                    </template>
                </el-result>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {EVENT_ROUTER_BACK, PubSubGlobal} from "@/utils/pubsub";

export default {
    name: "cpsite-send-complete",
    methods: {
        toReport() {
            this.$router.push('/cpsite/send-report');
            PubSubGlobal.publish(EVENT_ROUTER_BACK, "/cpsite/send-report");
        },
        toSend() {
            this.$router.push('/cpsite/send');
            PubSubGlobal.publish(EVENT_ROUTER_BACK, "/cpsite/send");
        }
    },
}
</script>

<style scoped>

</style>